var packages = {
    switch2: {
        id: 48145050730832,
        enabled: $('#switch2').data('auto-enable')
    },
    switch4: {
        id: 53304333304144,
        enabled: $('#switch4').data('auto-enable')
    }
};

// Refresh cart
function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));

    if (
        typeof theme !== 'undefined' &&
        theme.ajaxCart &&
        typeof theme.ajaxCart.update === 'function'
    ) {
        theme.ajaxCart.update();
    }
}

// Add / Remove package
function updatePackage(id, qty) {

    $.ajax({
        type: 'POST',
        url: qty ? '/cart/add.js' : '/cart/change.js',
        dataType: 'json',
        data: qty ? {
            id: id,
            quantity: qty
        } : {
            id: id,
            quantity: 0
        },
        success: refreshCart
    });

}

// Keep only one package in cart
setInterval(function () {

    $.getJSON('/cart.js', function (cart) {

        // Check if any NON-package product exists
        var hasOtherProduct = cart.items.some(function (cartItem) {

            return !Object.values(packages).some(function (pkg) {
                return pkg.id == cartItem.variant_id;
            });

        });

        $.each(packages, function (key, pkg) {

            var id = pkg.id;

            $.each(cart.items, function (i, item) {

                if (item.variant_id == id) {

                    // Remove package if only package products remain
                    if (!hasOtherProduct) {

                        updatePackage(id, 0);

                    }
                    // Prevent duplicate quantity
                    else if (item.quantity > 1) {

                        $.post('/cart/change.js', {
                            id: id,
                            quantity: 1
                        }, refreshCart);

                    }

                }

            });

        });

    });

}, 500);


// Checkbox change
$(document).on('change', '#switch2, #switch4', function (e) {

    e.preventDefault();

    var pkg = packages[this.id];

    if (!pkg) return;

    updatePackage(pkg.id, $(this).is(':checked') ? 1 : 0);

});


// Auto add on Add to Cart
$("button.btn.add-to-cart").click(function () {

    $.getJSON('/cart.js', function (cart) {

        var itemsToAdd = [];

        $.each(packages, function (key, pkg) {

            if (
                pkg.enabled &&
                $('#' + key).length &&
                !cart.items.some(function (item) {
                    return item.variant_id == pkg.id;
                })
            ) {

                itemsToAdd.push({
                    id: pkg.id,
                    quantity: 1
                });

                $('#' + key).prop('checked', true);

            }

        });

        if (itemsToAdd.length) {

            setTimeout(function () {

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({
                        items: itemsToAdd
                    }),
                    success: refreshCart
                });

            }, 500);

        }

    });

});

